import { Badge, Tooltip } from '@chakra-ui/react';
import React from 'react';

type ExternalEntityType = 'market' | 'practice' | 'provider';

interface ExternalAffordanceProps {
  entityType: ExternalEntityType;
  size?: 'sm' | 'md';
}

const tooltipByEntity: Record<ExternalEntityType, string | null> = {
  market: null,
  practice: 'External practice: this practice belongs to an external market.',
  provider:
    'External provider: this provider is only bridged to external practices.',
};

const ExternalAffordance: React.FC<ExternalAffordanceProps> = ({
  entityType,
  size = 'md',
}) => {
  const tooltipLabel = tooltipByEntity[entityType];

  const sizeStyles = size === 'sm'
    ? { fontSize: '0.625rem', px: '0.45rem', py: '0.1rem', minH: '1.25rem' }
    : { fontSize: '0.75rem', px: '0.5rem', py: '0.25rem', minH: '1.5rem' };

  const badge = (
    <Badge
      bg="orange.500"
      color="white"
      fontWeight={600}
      borderRadius="0.3125rem"
      textTransform="uppercase"
      letterSpacing="0.01em"
      display="inline-flex"
      alignItems="center"
      cursor={tooltipLabel ? 'help' : 'default'}
      {...sizeStyles}
    >
      External
    </Badge>
  );

  if (!tooltipLabel) {
    return badge;
  }

  return (
    <Tooltip label={tooltipLabel} hasArrow>
      {badge}
    </Tooltip>
  );
};

export default ExternalAffordance;
